import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { canOpenFirmwareRecovery } from '../Utils/system_settings_utils';

export default function FirmwareRecoveryButton({ controller, onClick }) {
  const { t } = useTranslation();
  if (!canOpenFirmwareRecovery(controller)) return null;

  return (
    <Button
      component={Link}
      to={`/controller/${controller.id}/system?recovery=1`}
      onClick={onClick}
      color="primary"
      variant="outlined">
      {t('firmware_recovery')}
    </Button>
  );
}
